module.exports = __webpack_public_path__ + "static/media/gymhome.d14143a1.png";